var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mcs-alert',{staticClass:"mt-3",attrs:{"boldText":"FREE Shipping","text":"now available on ALL cupsleeve orders!","type":"help"}})}
var staticRenderFns = []

export { render, staticRenderFns }